export * from './address-addressee-reference.service';
export * from './bank-reference.service';
export * from './brand-label-reference.service';
export * from './care-label-reference.service';
export * from './category-reference.service';
export * from './colour-reference.service';
export * from './commodity-reference.service';
export * from './connection-type-reference.service';
export * from './connections-reference.service';
export * from './contact-agreement-reference.service';
export * from './contact-type-reference.service';
export * from './cost-centre-reference.service';
export * from './count-system-reference.service';
export * from './country-reference.service';
export * from './credit-note-reason-reference.service';
export * from './credit-note-status-reference.service';
export * from './currency-reference.service';
export * from './customer-contact-reference.service';
export * from './customer-sub-type-reference.service';
export * from './customer-trade-group-reference.service';
export * from './customer-type-reference.service';
export * from './delivery-month-reference.service';
export * from './delivery-period-reference.service';
export * from './delivery-term-reference.service';
export * from './department-reference.service';
export * from './fabric-processing-fabric-reference.service';
export * from './fibre-grade-reference.service';
export * from './fibre-type-reference.service';
export * from './fibre-reference.service';
export * from './grade-reference.service';
export * from './invoice-status-reference.service';
export * from './label-placement-reference.service';
export * from './location-reference.service';
export * from './location-type-reference.service';
export * from './make-up-reference.service';
export * from './measure-description-reference.service';
export * from './mode-of-transport-reference.service';
export * from './moisture-reference.service';
export * from './new-care-label-reference.service';
export * from './nominal-code-reference.service';
export * from './order-line-status-reference.service';
export * from './order-source-reference.service';
export * from './order-status-reference.service';
export * from './order-type-reference.service';
export * from './origin-reference.service';
export * from './pack-type-reference.service';
export * from './packed-on-item-reference.service';
export * from './payment-term-reference.service';
export * from './port-reference.service';
export * from './price-band-reference.service';
export * from './price-group-reference.service';
export * from './price-list-reference.service';
export * from './printer-reference.service';
export * from './process-route-header-reference.service';
export * from './product-additional-product-cost-reference.service';
export * from './product-reference.service';
export * from './product-group-reference.service';
export * from './product-type-reference.service';
export * from './product-type-additional-product-cost-reference.service';
export * from './production-process-reference.service';
export * from './production-process-type-reference.service';
export * from './purchase-order-status-reference.service';
export * from './purchase-price-band-reference.service';
export * from './purchase-price-list-reference.service';
export * from './quality-reference.service';
export * from './sales-despatch-note-status-reference.service';
export * from './sales-discount-reference.service';
export * from './sales-region-reference.service';
export * from './selling-company-reference.service';
export * from './service-rep-eference.service';
export * from './settlement-term-reference.service';
export * from './size-reference.service';
export * from './shipper-account-interface-type-reference.service';
export * from './stock-adjustment-reason-reference.service';
export * from './supplier-reference.service';
export * from './tax-reference.service';
export * from './title-reference.service';
export * from './torque-direction-reference.service';
export * from './trim-description-reference.service';
export * from './twist-direction-reference.service';
export * from './unit-of-measure-reference.service';
export * from './user-reference.service';
export * from './warehouse-reference.service';
export * from './web-payment-method-reference.service';
export * from './yarn-property1-reference.service';
export * from './yarn-quality-reference.service';
